import APIClient from './index';

export const getUser = (id) =>
  new Promise((resolve, reject) =>
    APIClient.get(`/users/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data))
  );

export const getUsers = (params) =>
  new Promise((resolve, reject) =>
    APIClient.get(`/users?${new URLSearchParams(params).toString()}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data))
  );
export const loginUser = (params) =>
  new Promise((resolve, reject) =>
    APIClient.post('/dj-rest-auth/login/', params, { skipAuth: true })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data))
  );

export const registerUser = (params) =>
  new Promise((resolve, reject) =>
    APIClient.post('/dj-rest-auth/registration/', params, { skipAuth: true })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data || error?.data))
  );

export const resetPassword = (params) =>
  new Promise((resolve, reject) =>
    APIClient.post('/dj-rest-auth/password/reset/confirm/', params, { skipAuth: true })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data))
  );

export const requestNewPassword = (params) =>
  new Promise((resolve, reject) =>
    APIClient.post('/dj-rest-auth/password/reset/', params, { skipAuth: true })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data))
  );

export const refreshAccessToken = (params) =>
  new Promise((resolve, reject) =>
    APIClient.post('/dj-rest-auth/token/refresh/', params, { skipAuth: true })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const connectZoomAccount = (code) => {
  const redirect_uri = window.__IS_PROD__ ? 'https://app.chipbrain.com/account?type=zoom' : 'https://staging.chipbrain.com/account?type=zoom';
  return new Promise((resolve, reject) =>
    APIClient.post('/zoom/connect', { code, redirect_uri })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );
};

export const connectHubspotAccount = (code) => {
  return new Promise((resolve, reject) =>
    APIClient.post('/hubspot/connect', { code })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );
};
